import * as yup from 'yup';

/** Common validation schema for transforming a boolean value even in the absence */
export const booleanSchema = yup
  .boolean()
  .transform(value => ([undefined, null, 'false'].includes(value)) ? false : !!value);
